export class CatalogCheckNameResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "databaseNameValid",
            "baseName": "databaseNameValid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "databaseNameReason",
            "baseName": "databaseNameReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "databaseExists",
            "baseName": "databaseExists",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tableExists",
            "baseName": "tableExists",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "existingTableSchema",
            "baseName": "existingTableSchema",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "tableNameValid",
            "baseName": "tableNameValid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tableNameReason",
            "baseName": "tableNameReason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogCheckNameResponse.attributeTypeMap;
    }
    constructor() {
    }
}
